<div class="renderer-container" *ngIf="ready$ | async">
  <ng-container *ngIf="model; else empty">
    <mat-chip *ngIf="!isMultiMode" [matTooltip]="model.retailers.toolTip" class="mat-chip-xsmall default">{{model.retailers.label}}</mat-chip>
    <mat-chip class="mat-chip-xsmall default">{{ model.dateRange }}</mat-chip>
    <mat-chip [matTooltip]="model.filters.toolTip" class="mat-chip-xsmall default">{{model.filters.label}}</mat-chip>
  </ng-container>
  <ng-template #empty>
    <mat-chip class="mat-chip-xsmall default">Empty Report</mat-chip>
  </ng-template>
</div>